// schema
import * as ISchema from "#webapp/src/__schema__";

import {
  setActiveViewDay,
  setActiveViewFeed,
} from "#webapp/src/state/actions/chrome-extension.actions";
import {
  setSelectedMoment,
  setSnapToSelectedMomentOnNextMount,
} from "#webapp/src/state/actions/day-view.actions";
import {
  makeEventSchedulerViewActive,
  updateEventSchedulerHasUnsavedChanges,
  updateFeedSchedulerInput,
  updateScheduledEventIds,
} from "#webapp/src/state/actions/feed-scheduler.actions";
import { IReduxState } from "#webapp/src/state/reducers/root.reducer";
import { EFlex } from "#webapp/src/util/event-tag.util";
import { EScheduleRange } from "#webapp/src/util/scheduler.util";
import { IFeatureGridReduxState } from "@clockwise/web-commons/src/util/feature-grid.util";
import { Environment, RelayRefetchProp } from "react-relay";

export enum RoomOptionEnum {
  WithRoom = "WithRoom",
  WithoutRoom = "WithoutRoom",
  SpecificRoom = "SpecificRoom",
}

export enum VideoConferencingEnum {
  GoogleMeet = "GoogleMeet",
  Zoom = "Zoom",
  None = "None",
}

export interface IRendererProps {
  environment: Environment;
}

export interface IContainer {
  viewer: ISchema.IViewer;
  onAttendeeChange?: (attendees: string[]) => void;
}

export interface IProps extends IContainer {
  relay: RelayRefetchProp;
  updateFeedSchedulerInput: typeof updateFeedSchedulerInput;
  calendarIds: IReduxState["feedScheduler"]["calendarIds"];
  roomRequired: IReduxState["feedScheduler"]["roomRequired"];
  calendarSelectionStates: IReduxState["webExtension"]["calendarSelectionStates"];
  schedulingSessionId: IReduxState["feedScheduler"]["schedulingSessionId"];
  makeEventSchedulerViewActive: typeof makeEventSchedulerViewActive;
  setActiveViewDay: typeof setActiveViewDay;
  setActiveViewFeed: typeof setActiveViewFeed;
  setSelectedMoment: typeof setSelectedMoment;
  setSnapToSelectedMomentOnNextMount: typeof setSnapToSelectedMomentOnNextMount;
  updateEventSchedulerHasUnsavedChanges: typeof updateEventSchedulerHasUnsavedChanges;
  updateScheduledEventIds: typeof updateScheduledEventIds;
  reschedulerEvent: IReduxState["feedScheduler"]["reschedulerEvent"];
  useAutoSchedule: IReduxState["feedScheduler"]["useAutoSchedule"];
  minutesDuration: IReduxState["feedScheduler"]["minutesDuration"];
  range: IReduxState["feedScheduler"]["range"];
  specifiedDate: IReduxState["feedScheduler"]["specifiedDate"];
  featureGrid: IFeatureGridReduxState;
  isWebExtension: IReduxState["webExtension"]["isWebExtension"];
}

export interface IState {
  title: string;
  calendarIds: string[];
  minutesDuration: number;
  includeRoom: RoomOptionEnum;
  range: EScheduleRange;
  specifiedDate: Date | null;
  roomIds: string[];
  description: string;
  location: string;
  includeZoomLink: boolean;
  selectedSlot?: ISchema.ISchedulingSlot;
  savingEvent: boolean;
  openingInGCal: boolean;
  focusEventTitle: boolean;
  titleError: string;
  timeError: string;
  uncrawledCalendarsCount: number;
  openRoomInput: boolean;
  useAutoSchedule: boolean;
  flex: EFlex;
  allowSimilarRooms: boolean;
  conflictResolutionDefragId?: string;
  allowedStart: ISchema.IDayOffsetTimeSlot | null;
  allowedEnd: ISchema.IDayOffsetTimeSlot | null;
  recurrenceOption?: ISchema.RecurrenceOption;
}
